import React from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import BenefitsSection from './components/BenefitsSection';
import ResultsSection from './components/ResultsSection';
import ComparisonSection from './components/ComparisonSection';
import HowItWorksSection from './components/HowItWorksSection';
import GuaranteeSection from './components/GuaranteeSection';
import FAQSection from './components/FAQSection';
import QuizCTASection from './components/QuizCTASection';
import ContactBookingSection from './components/ContactBookingSection';
import UrgencySection from './components/UrgencySection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <ProblemSection />
      <SolutionSection />
      <BenefitsSection />
      <ResultsSection />
      <ComparisonSection />
      <HowItWorksSection />
      <GuaranteeSection />
      <FAQSection />
      <QuizCTASection />
      <ContactBookingSection />
      <UrgencySection />
      <Footer />
    </div>
  );
}

export default App;